module.exports = __webpack_public_path__ + "media/images/newly-d6796f6303982c9b06ab4f096a1bbfed.png";